import { WebPost, StatusCode, IAPIResponse } from "api/protocols";
import { IUser } from "redux/reducers/models/user";
import { IFacility } from "redux/reducers/models/facility";

interface IEnterFacilityParams {
  facility_id: number;
}

interface IEnterFacilityRes {
  user: IUser & { support_session?: boolean };
  facility: IFacility;
  support_session: boolean;
  session: boolean;
}

interface IExitFacilityRes {
  user: IUser;
  support_session: boolean;
  session: boolean;
}

/**
 * Enter Facility Admin as support for a selected facility.
 * Master Admin or Client Admin with facility_admin_enter; uses the cookie session (same as /login).
 */
export async function EnterSupportFacility(
  params: IEnterFacilityParams,
  useGlobalLoader: boolean,
): Promise<IAPIResponse<IEnterFacilityRes>> {
  return WebPost("support/enter-facility", params, useGlobalLoader);
}

/**
 * Exit a support Facility Admin session and return to Master Admin or Client Admin.
 */
export async function ExitSupportFacility(
  useGlobalLoader: boolean,
): Promise<IAPIResponse<IExitFacilityRes>> {
  return WebPost("support/exit-facility", {}, useGlobalLoader);
}

export { StatusCode };
